import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { IntroLoader } from "@/components/IntroLoader";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Positioning } from "@/components/Positioning";
import { Services } from "@/components/Services";
import { AIHuman } from "@/components/AIHuman";
import { AIPipeline } from "@/components/AIPipeline";
import { WhatWeBuild } from "@/components/WhatWeBuild";
import { Process } from "@/components/Process";
import { Portfolio } from "@/components/Portfolio";
import { Trust } from "@/components/Trust";
import { Industries } from "@/components/Industries";
import { CTASection } from "@/components/CTASection";
import { Footer } from "@/components/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  const [loading, setLoading] = useState(true);

  usePageMeta({
    title: "BrandZenith | AI-Powered Brand Growth Studio",
    description:
      "BrandZenith is an AI-powered brand growth studio helping businesses build, launch and grow through strategy, creative design, content, websites and AI-powered marketing.",
    path: "/",
  });

  return (
    <>
      <AnimatePresence>
        {loading && <IntroLoader onDone={() => setLoading(false)} />}
      </AnimatePresence>
      {!loading && (
        <>
          <Navbar />
          <main>
            <Hero />
            <Marquee />
            <Positioning />
            <Services />
            <AIHuman />
            <AIPipeline />
            <WhatWeBuild />
            <Process />
            <Portfolio />
            <Trust />
            <Industries />
            <CTASection />
          </main>
          <Footer />
        </>
      )}
    </>
  );
}
